import script from "./HbwlProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HbwlProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./HbwlProductComponent.vue?vue&type=style&index=0&id=6e806dbc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e806dbc"]])

export default __exports__